import React, { useEffect, useState } from 'react';
import {Chart} from 'react-google-charts'
//
// const data1 = [
//   ["Year", "Visitations", {role: "style"}],
//   ["2010", 10, "color: gray"],
//   ["2020", 14, "color: #76A7FA"],
//   ["2030", 16, "color: blue"],
//   ["2040", 22, "stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF"],
//   ["2040", 22, "stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF"],
//   ["2040", 22, "stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF"],
//   ["2040", 22, "stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF"],
//   ["2040", 22, "stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF"],
//   [
//     "2050",
//     28,
//     "stroke-color: #871B47; stroke-opacity: 0.6; stroke-width: 8; fill-color: #000; fill-opacity: 2"
//   ]
// ];



function Index(props) {
  const [serviceData, setServiceData] = useState();
  const {data, chartType,ServicesType} = props;

  /** To show single service data in chart */
  const index = data[0].findIndex(x => x == ServicesType);
  useEffect(() => {
    let arr=[];
    if(index != -1){
      for (let i = 0; i < data.length; i++) {
        arr.push([data[i][0], data[i][index]]);
      }
      setServiceData(arr);
    }else{
      setServiceData(data);
    }
  }, [ServicesType]);

  let [xAxisLabel, yAxisLabel] = chartType === 'BarChart' ? ['Gross Revenue (PKR)', 'Time Duration (Month)'] : ['Time Duration (Month)', 'Gross Revenue (PKR)']
  return (
    <div>
      <Chart
        width={'100%'}
        chartType={chartType}
        data={serviceData}
        loader={<div style={{color:"#36ba7f"}}>Loading Chart...</div>}
        // height={'600px'}
        // style={{paddingLeft: 20}}
        options={{
          title: 'Gross Revenue Report',
          width: '100%',
          height: 500,
          lineWidth: 5,
          bar: {groupWidth: (ServicesType == 'All') ? "90%" : "50%" },
          // 'colors' : ["#194D86","#699A36", "#000000"],
          // chartArea: {width: '50%'},
          // isStacked: true,
          hAxis: {
            title: xAxisLabel,
            minValue: 0,
          },
          vAxis: {
            title: yAxisLabel,
          },
        }}
        
        // options={{
        //   // Material design options
        //   // colors: ['#b0120a', '#faac91', '#ffab01'],
        //   // width: 400,
        //   // height: 400,
        //   // chartArea: 100,
        //   // is3D: false,
        //   chart: {
        //     title: 'Company Performance',
        //     subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        //   },
        //   // bar: {groupWidth: '50%', barWidth: '50%',},
        //
        // }}

        // For tests
        // rootProps={{'data-testid': '6'}}
      />
     
    </div>
  );
}

export default Index;

